var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'יש לנו כמה שאלות...',"text":'כדי להכין לך תזרים מדויק, נצטרך תשובות לכמה שאלות. זה יקח רק דקה.',"notification-buttons":[
                  {
                    title:'לדיוק התזרים',
                    variant: 'primary',
                    action: _vm.openInvestigation,
                  } ],"icon-type":'warning'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }